import React from "react";
import { useField, useFormikContext } from "formik";
import { PatternFormat } from "react-number-format";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import convertString from "helpers/convertString";
import { get, isEmpty } from "lodash";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors, value) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !isEmpty(value) && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

function InputMaskField(props) {
  const {
    name,
    label,
    placeholder,
    format,
    mask,
    withFeedbackLabel = true,
    type = "text",
    customFeedbackLabel,
    onChange,
    infoText,
    classes,
    showLabel = true,
    disabled = false
  } = props;
  const { setFieldValue, touched, errors } = useFormikContext();
  const [field] = useField(props);
  return (
    <div style={{ marginBottom: "1.75rem" }} className={classes && classes}>
      {showLabel && (
        <div className="d-flex">
          {label && (
            <label>
              <FormattedMessage id={label} />
            </label>
          )}
          {infoText && <div className="ml-2 text-muted lms-form-info-text">{infoText}</div>}
        </div>
      )}
      <PatternFormat
        {...props}
        {...field}
        className={getFieldCSSClasses(
          get(touched, field.name),
          get(errors, field.name),
          field.value
        )}
        name={name}
        placeholder={placeholder}
        format={format}
        mask={mask}
        onValueChange={({ value }) => {
          setFieldValue(name, value);
          onChange && onChange(value);
        }}
        id={convertString(label)}
        disabled={disabled}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={get(errors, field.name)}
          touched={get(touched, field.name)}
          label={<FormattedMessage id={label} />}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </div>
  );
}

InputMaskField.propTypes = {
  name: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired
};

export default InputMaskField;
